import { X, BarChart3, Bell, BookOpen } from "lucide-react";
import { motion, AnimatePresence } from "framer-motion";
import { Link } from "react-router-dom";

interface WelcomeModalProps {
  isOpen: boolean;
  onClose: () => void;
}

export default function WelcomeModal({ isOpen, onClose }: WelcomeModalProps) {
  return (
    <AnimatePresence>
      {isOpen && (
        <div
          className="fixed inset-0 z-50 flex items-center justify-center p-4 bg-black/60 backdrop-blur-sm"
          onClick={onClose}
        >
          <motion.div
            initial={{ opacity: 0, scale: 0.95, y: 10 }}
            animate={{ opacity: 1, scale: 1, y: 0 }}
            exit={{ opacity: 0, scale: 0.95, y: 10 }}
            transition={{ duration: 0.2 }}
            onClick={(e) => e.stopPropagation()}
            className="bg-navy-dark border border-sky-blue/20 rounded-2xl shadow-2xl w-full max-w-md overflow-hidden"
          >
            <div className="relative bg-gradient-to-br from-sky-blue/10 to-transparent p-8 pb-6">
              <button
                onClick={onClose}
                className="absolute top-4 right-4 text-white/40 hover:text-white transition"
              >
                <X size={20} />
              </button>
              <h2 className="text-2xl font-bold text-white mb-2">Welcome to ResidualVault</h2>
              <p className="text-white/60 text-sm">Three things to do in your first 5 minutes:</p>
            </div>

            <div className="px-8 py-6 space-y-4">
              <Link
                to="/staking"
                onClick={onClose}
                className="flex items-center gap-4 p-3 rounded-xl bg-steel-blue/10 hover:bg-steel-blue/20 transition group"
              >
                <div className="w-10 h-10 rounded-lg bg-sky-blue/20 flex items-center justify-center">
                  <BarChart3 size={20} className="text-sky-blue" />
                </div>
                <div>
                  <p className="text-white font-medium text-sm group-hover:text-sky-blue transition">Run your first protocol comparison</p>
                  <p className="text-white/40 text-xs">Compare APY, TVL, and risk across protocols</p>
                </div>
              </Link>

              <Link
                to="/staking"
                onClick={onClose}
                className="flex items-center gap-4 p-3 rounded-xl bg-steel-blue/10 hover:bg-steel-blue/20 transition group"
              >
                <div className="w-10 h-10 rounded-lg bg-sky-blue/20 flex items-center justify-center">
                  <Bell size={20} className="text-sky-blue" />
                </div>
                <div>
                  <p className="text-white font-medium text-sm group-hover:text-sky-blue transition">Set your first APY alert</p>
                  <p className="text-white/40 text-xs">Get notified when yields move</p>
                </div>
              </Link>

              <Link
                to="/store"
                onClick={onClose}
                className="flex items-center gap-4 p-3 rounded-xl bg-steel-blue/10 hover:bg-steel-blue/20 transition group"
              >
                <div className="w-10 h-10 rounded-lg bg-sky-blue/20 flex items-center justify-center">
                  <BookOpen size={20} className="text-sky-blue" />
                </div>
                <div>
                  <p className="text-white font-medium text-sm group-hover:text-sky-blue transition">Download your free chapter</p>
                  <p className="text-white/40 text-xs">The Crypto Staking Intelligence Guide</p>
                </div>
              </Link>
            </div>

            <div className="px-8 pb-8">
              <Link
                to="/staking"
                onClick={onClose}
                className="block w-full text-center py-3 px-6 bg-sky-blue hover:bg-sky-blue/90 text-navy-dark font-bold rounded-xl transition text-sm"
              >
                Start Comparing →
              </Link>
            </div>
          </motion.div>
        </div>
      )}
    </AnimatePresence>
  );
}
